export default __webpack_public_path__ + "static/media/p15.37e588bc.jpg";